/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, Button, ButtonGroup, IconButton, SwipeableDrawer, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { act, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SelectBoxSearch from "src/shared/components/select_box_search";
import { selectGtoState, useDispatch, gerenciaTecnicaSlice } from "src/stateManagement/redux";
import { getLocations } from "src/stateManagement/redux/slices/gerencia_tecnica/asyncReducers";
import { Location } from "src/stateManagement/redux/slices/location/interfaces";
import TuneIcon from '@mui/icons-material/Tune';
import CloseIcon from '@mui/icons-material/Close';
import { Filter, FilterDrawer, FilterList } from "src/shared/modules/filterDrawer";
import moment from "moment";

const defaultFilters: FilterList[] = [
    {
        name: 'Fecha Inicio',
        field: 'fromDate',
        type: 'date',
        action: 'equalAfter',
        buttons: [],
        options: []
    },
    {
        name: 'Fecha Fin',
        field: 'toDate',
        type: 'date',
        action: 'equalBefore',
        buttons: [],
        options: []
    },
    {
        name: 'Metodo',
        field: 'method',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['BM', 'BCP', 'ESP', 'Gas Lift']
    },
    {
        name: 'Campo',
        field: 'field',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['Bachaquero', 'Lagunillas']
    },
    {
        name: 'Cartas Por analizar',
        field: 'cardsWithoutAnalyst',
        type: 'groupButton',
        buttons: [
            { id: 0, name: 'Todo', value: '', action: 'dissable' },
            { id: 1, name: 'SI', value: 0, action: 'greater' },
            { id: 2, name: 'NO', value: 1, action: 'less' }
        ],
        options: []
    },
    {
        name: 'Niveles Por analizar',
        field: 'pendingLiquidLevel',
        type: 'groupButton',
        buttons: [
            { id: 0, name: 'Todo', value: '', action: 'dissable' },
            { id: 1, name: 'SI', value: 0, action: 'greater' },
            { id: 2, name: 'NO', value: 1, action: 'less' }
        ],
        options: []
    },
    {
        name: 'Con Data de Campo',
        field: 'activityId',
        type: 'groupButton',
        buttons: [
            { id: 0, name: 'Todo', value: "", action: 'dissable' },
            { id: 1, name: 'SI', value: "", action: 'different' },
            { id: 2, name: 'NO', value: "", action: 'equal' }
        ],
        options: []
    },
    {
        name: 'Sector',
        field: 'zone',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ["BTS1", "BTS2", "BTN2", "BTN3", "BTNB", "LGN2", "LGS1", "LGN1", "LGS2", "BTNA"]
    },
    {
        name: 'Estado Operativo Inicio',
        field: 'opeStatusInicio',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['Operando', 'Sin Aporte', 'Aportando', 'Restaurado', 'Recolocado', 'Sin Producción', 'IT', 'Sin Acceso', 'Observación']
    },
    {
        name: 'Estado Operativo Fin',
        field: 'opeStatusFin',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['Operando', 'Sin Aporte', 'Aportando', 'Restaurado', 'Recolocado', 'Sin Producción', 'IT', 'Sin Acceso', 'Observación']
    }
]

const ListLocation = () => {
    const dispatch = useDispatch();
    const { locations, locationListFilter } = useSelector(selectGtoState);
    const options: string[] = ["Locación"];
    const [data, setData] = useState<Location[]>([]);
    const [selectedOption, setSelectedOption] = useState(options[0]);
    const [inputValueFilter, setInputValueFilter] = useState<string>("");
    const [filteredData, setFilteredData] = useState<Filter[]>([]);
    const [filters, setfilters] = useState<FilterList[]>(defaultFilters)
    const [loadFilterFromState, setloadFilterFromState] = useState(true)

    const [showFilters, setshowFilters] = useState(false)

    useEffect(() => {
        dispatch(getLocations());
    }, []);

    useEffect(() => {
        if (loadFilterFromState && locationListFilter) {
            
            const parsedFilters = JSON.parse(locationListFilter);
            if (parsedFilters && parsedFilters.length > 0) {
                const newFilters = []
                for (const filter of parsedFilters) {
                    if (typeof filter.value === "string" && (filter.action === 'equalAfter' || filter.action === 'equalBefore')) {
                        newFilters.push({
                            ...filter,
                            value: moment(filter.value)
                        })
                    }else if (filter.name === "filterInput") {
                        setInputValueFilter(filter.inputValueFilter || "");
                    } else{
                        newFilters.push(filter)
                    }
                }
                setFilteredData(newFilters);
                setloadFilterFromState(false)
            }
        }
    }, [locationListFilter])
    

    useEffect(() => {
        let allLocations = locations || [];

        const flags: any[] = []
        const warnings: any[] = []

        for (const location of allLocations) {
            if (!location?.locationTag || location?.locationTag?.length === 0) continue

            location?.locationTag?.forEach((tag: any) => {
                if (tag?.type === 'warning') {
                    if (!warnings.includes(tag?.name)) {
                        warnings.push(tag?.name);
                    }
                }
                if (tag?.type === 'flag') {
                    if (!flags.includes(tag?.name)) {
                        flags.push(tag?.name);
                    }
                }
            })

        }

        setfilters([
            ...defaultFilters,
            {
                name: 'Etiquetas',
                field: 'locationTag',
                subField: 'name',
                type: 'Autocomplete',
                action: 'arrayInclude',
                buttons: [],
                options: flags
            },
            {
                name: 'Alertas',
                field: 'locationTag',
                subField: 'name',
                type: 'Autocomplete',
                action: 'arrayInclude',
                buttons: [],
                options: warnings
            }
        ])


        if (inputValueFilter !== "") {
            allLocations = allLocations.filter((x) => x.locationName.toLowerCase().includes(inputValueFilter.toLowerCase()));
        }

        for (const filter of filters) {
            const filterData = filteredData.find(f => f.name === filter.name);
          
            if (filterData) {
                if (filterData.action === 'greater') {
                    allLocations = allLocations.filter((x) => x[filter.field] > filterData.value);
                } else if (filterData.action === 'less') {
                    allLocations = allLocations.filter((x) => x[filter.field] < filterData.value);
                } else if (filterData.action === 'equal') {
                    allLocations = allLocations.filter((x) => x[filter.field] === filterData.value);
                } else if (filterData.action === 'different') {
                    allLocations = allLocations.filter((x) => x[filter.field] !== filterData.value);
                } else if (filterData.action === 'arrayInclude') {
                    if (filter.subField && filterData.value.length > 0) {
                        allLocations = allLocations.filter((x) => {
                            const locationTags = x[filter.field]?.map((tag: any) => tag[filter.subField as keyof typeof tag]);
                            return locationTags?.some((tag: any) => filterData.value.includes(tag));
                        });
                    }
                } else if (filterData.action === 'include' && filterData.value.length > 0) {
                    allLocations = allLocations.filter((x) => filterData.value.includes(x[filter.field]));
                } else if (filterData.action === 'equalAfter') {
                    allLocations = allLocations.filter((x) => {
                        const locationDate = moment(x.executedDate);
                        return locationDate.isSameOrAfter(filterData.value, 'day')
                    });
                } else if (filterData.action === 'equalBefore') {
                    allLocations = allLocations.filter((x) => {
                        const locationDate = moment(x.executedDate)
                        return locationDate.isSameOrBefore(filterData.value, 'day')
                    });
                }
            }
        }

        setData(allLocations);
    }, [locations, inputValueFilter, filteredData]);

    const handleSelectChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setSelectedOption(event.target.value);
        setInputValueFilter("");
    };

    const handleFilterInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValueFilter(event.target.value);
        dispatch(gerenciaTecnicaSlice.actions.setLocationListFilter(JSON.stringify([...filteredData,{
            inputValueFilter:event.target.value,
            name:'filterInput',
        }])));
    };

    const handleSelectOptionFilter = (filter: Filter) => {
        const extraFilter = filteredData.filter(f => f.name !== filter.name);
        setFilteredData([...extraFilter, filter]);
        dispatch(gerenciaTecnicaSlice.actions.setLocationListFilter(JSON.stringify([
            ...extraFilter, 
            filter])));
    };

    const handleResetSearch = () => {
        setFilteredData([]);
        setInputValueFilter("");
        setData(locations || []);
         dispatch(gerenciaTecnicaSlice.actions.setLocationListFilter(JSON.stringify([])));
    };

    const paginationModel = { page: 0, pageSize: 10 };
    const columns: GridColDef[] = [
        { field: "locationName", headerName: "Locación", flex: 1 },
        { field: "method", headerName: "Metodo", flex: 0.5 },
        { field: "executedDate", headerName: "Fecha", flex: 1 },
        // { field: "opeStatusInicio", headerName: "Ope Status Inicio", flex: 1 },
        { field: "zone", headerName: "Sector", flex: 1 },
        { field: "opeStatusInicio", headerName: "Ope Status Ini", flex: 1 },
        { field: "opeStatusFin", headerName: "Ope Status Fin", flex: 1 },
        { field: "pot", headerName: "Pot", flex: 1 },
        { field: "activity", headerName: "Actividad", flex: 1 },
        { field: "cardsWithoutAnalyst", headerName: "Cartas por analizar", flex: 1 },
        { field: "pendingLiquidLevel", headerName: "Niveles Pendientes", flex: 1 },
        {
            field: "action",
            headerName: "",
            sortable: false,
            flex: 0.8,
            renderCell: (params) => {
                return (
                    <Link
                        to={`/gto/dashboard/location/detail/${params.row.locationId}`}
                    >
                        <Button variant="contained" size="small" fullWidth>
                            Detalles
                        </Button>
                    </Link>
                );
            },
        },
    ];

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid size={12} sx={{ mt: 2 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            alignContent: "center",
                        }}
                    >
                        <SelectBoxSearch
                            options={options}
                            selectedOption={selectedOption}
                            onOptionChangeSelectBox={handleSelectChange}
                            onValueChangeInput={handleFilterInput}
                            inputValue={inputValueFilter}
                        />
                        <IconButton
                            size="small"
                            color="primary"
                            sx={{ mr: 2 }}
                            onClick={() => setshowFilters(!showFilters)}
                        >
                            <TuneIcon />
                        </IconButton>
                    </Box>
                </Grid>
                <FilterDrawer
                    showFilters={showFilters}
                    filters={filters}
                    filteredData={filteredData}
                    setshowFilters={setshowFilters}
                    handleSelectOptionFilter={handleSelectOptionFilter}
                    resetFilters={handleResetSearch}
                />

                <Grid size={12}>
                    <DataGrid
                        rows={data}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeader": {
                                backgroundColor: "#316EBC",
                                color: "#fff",
                                fontWeight: "bold",
                            },
                            height: {
                                md: `calc(100vh - 270px)`,
                                lg: `calc(100vh - 270px)`,
                            },
                        }}
                        getRowId={(row) => row.locationId}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default ListLocation;
